import { Size } from '../../primitives/size';
import { DiagramElement } from './diagram-element';
import { measureImage } from './../../utility/dom-util';
/**
 * ImageElement defines a basic image elements
 */
export class ImageElement extends DiagramElement {
    /**
     * set the id for each element
     */
    constructor() {
        super();
        /**
         * sets or gets the image source
         */
        this.imageSource = '';
        /**
         * sets scaling factor of the image
         */
        this.imageScale = 'None';
        /**
         * sets the alignment of the image
         */
        this.imageAlign = 'None';
        /**
         * Sets how to stretch the image
         */
        this.stretch = 'Stretch';
    }
    /**
     * Gets the source for the image element
     */
    /**
     * Gets the source for the image element \
     *
     * @returns { void }Gets the source for the image element.\
     *
     * @private
     */
    get source() {
        return this.imageSource;
    }
    /**
     * Sets the source for the image element \
     *
     * @returns { void }Sets the source for the image element.\
     * @param {string} value - provide the id value.
     *
     * @private
     */
    set source(value) {
        this.imageSource = value;
        this.isDirt = true;
    }
    /**
     * Measures minimum space that is required to render the image \
     *
     * @returns { Size }Measures minimum space that is required to render the image.\
     * @param {Size} availableSize - provide the id value.
     * @param {Object} id - provide the id value.
     * @param {Function} callback - provide the id value.
     *
     * @private
     */
    measure(availableSize, id, callback) {
        if (this.isDirt && (this.stretch !== 'Stretch' || this.width === undefined && this.height === undefined)) {
            this.contentSize = measureImage(this.source, this.contentSize, id, callback);
            this.isDirt = false;
        }
        if (this.width !== undefined && this.height !== undefined) {
            this.desiredSize = new Size(this.width, this.height);
            this.contentSize = this.desiredSize;
        }
        else {
            this.desiredSize = this.contentSize;
        }
        this.desiredSize = this.validateDesiredSize(this.desiredSize, availableSize);
        return this.desiredSize;
    }
    /**
     * Arranges the image
     * @param {Size} desiredSize
     */
    /**
     * Arranges the image \
     *
     * @returns { Size }Arranges the image.\
     * @param {Size} desiredSize - provide the id value.
     *
     * @private
     */
    arrange(desiredSize) {
        this.actualSize = new Size(this.desiredSize.width, this.desiredSize.height);
        this.updateBounds();
        return this.actualSize;
    }
}
